import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export type ChangeEmailResult = {
  migsUpdated: boolean;
  idokUpdated: boolean;
  message: string;
  noChange?: boolean;
  email?: string;
};

const CONNECTION_ERROR: ChangeEmailResult = {
  migsUpdated: false,
  idokUpdated: false,
  message: "No se pudo conectar con el servidor. No se realizaron cambios.",
};

export const changeUserEmail = createAsyncThunk<
  ChangeEmailResult,
  { id: string | number; email: string },
  { rejectValue: ChangeEmailResult }
>("userUpdate/changeUserEmail", async ({ id, email }, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.patch(`${api.baseURL}user/change-email`, {
      id: Number(id),
      email,
    });
    return data as ChangeEmailResult;
  } catch (error: any) {
    const data = error?.response?.data;
    if (data && typeof data === "object" && typeof data.message === "string") {
      return rejectWithValue({
        migsUpdated: !!data.migsUpdated,
        idokUpdated: !!data.idokUpdated,
        message: data.message,
      });
    }
    return rejectWithValue(CONNECTION_ERROR);
  }
});
